import { render, staticRenderFns } from "./IngestStats.vue?vue&type=template&id=61bff6fb"
import script from "./IngestStats.vue?vue&type=script&lang=ts"
export * from "./IngestStats.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports